// define([
// 	'jquery',
// 	'underscore',
// 	'slider',
// 	'jquery-outside'

import $ from 'jquery';
import _ from 'underscore';
import slider from '../../vendor/slider';
import '../../vendor/jquery.outside-events';

var container = $('.nav-helper');
var groups = $('.nav-group', container);
var contents = $('.nav-content', container);
var triggers = $('.nav-trigger', container);
var activeClass = 'js-active';

slider.initElements(contents);
$(window).resize(_.debounce(resetAll, 400));

triggers.on('click', function (e) {
  var parent = $(this).parent('.nav-group');
  var content = $(this).next('.nav-content');

  if (slider.isAnimating(content)) {
    return;
  }

  var isOpen;
  parent.hasClass(activeClass) ? (isOpen = true) : (isOpen = false);

  resetAll();

  // toggle the state of the selected group
  if (isOpen) {
    parent.removeClass(activeClass);
    slider.slideUp(content);
  } else {
    parent.addClass(activeClass);
    slider.slideDown(content);
  }
});

container.on('clickoutside', resetAll);

function resetAll() {
  groups.removeClass(activeClass);
  slider.slideUp(contents);
}
